export const LOAD_GMUSERS = "LOAD_GMUSERS"
export const loadGMUsersAction = GMUsers => ({
   type: LOAD_GMUSERS,
   payload: GMUsers
})